<template>
    <div class="row">
        <div class="col-md-10 col-12 pl-md-5 pr-md-5">
            <div class="row">
                <div class="col-md-12 mb-3">
                    <h5 class="text-uppercase">Emailadres bewerken</h5>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="name">Emailadres:</label>
                        <input type="text" class="form-control" id="name" v-model="emailaddress">
                    </div>
                </div>

				<div class="col-md-12">
                    <div class="form-group">
                        <label for="name">Leden:</label>
                        <select2-multiple-control v-model="users" 
                          :options="format_user_arr" 
                          @change="myChangeEvent($event)" 
                          @select="mySelectEvent($event)" 
                        />
                    </div>
                </div>

				<div class="col-md-12">
                    <div class="form-group">
                        <label for="name">Commissies:</label>
                        <select2-multiple-control v-model="committees" 
                         :options="format_committees_arr" 
                         @change="myChangeEvent($event)" 
                         @select="mySelectEvent($event)" 
                        />

                    </div>
                </div>

				<div class="col-md-12" style="margin-bottom: 20px;">
                    <div class="form-check">
						<input class="form-check-input" type="checkbox" value="1" id="flexCheckPublic" v-model="publiccheck">
						<label class="form-check-label" for="flexCheckPublic">
							Publiek
						</label>
					</div>
                </div>

				<div class="col-md-12" style="margin-bottom: 20px;">
                    <div class="form-check">
						<input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" v-model="defaultcheck">
						<label class="form-check-label" for="flexCheckDefault">
							Standaard
						</label>
					</div>
                </div>
                
                
                <input type="hidden" v-model="settings">

                <div class="col-md-12">
                    <div class="form-group">
                        <label for="textarea">Handtekening:</label>
                        <editor
							id="textarea1"
							v-model="footer"
							:init="{
								height: 200,
								menubar: false,
								language:'nl',
								plugins: [
									'advlist autolink lists link image charmap print preview anchor',
									'searchreplace visualblocks code fullscreen',
									'insertdatetime media table paste code help wordcount'
								],
								toolbar:
									'undo redo | formatselect | bold italic backcolor | \
									alignleft aligncenter alignright alignjustify | \
									bullist numlist outdent indent | removeformat | help'
							}"
                        />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <button class="btn-dark float-right mt-3" v-on:click="updateEmailaddress">Opslaan</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Select2MultipleControl from 'v-select2-multiple-component';
import { mapActions } from 'vuex';
export default {
    components :{
        Select2MultipleControl
    },
    props:['isEdit','committee','parents_id'],
        data(){
        return{
            committees_arr : [],
            format_committees_arr : [],
            users_arr: [],
            format_user_arr: [],
            emailaddress:'',
            users:[],
            committees:[],
            publiccheck:'',
            defaultcheck:'',
            settings:'',
			footer:'',
            id: '',
        }
    },
    methods:{
        ...mapActions({
                displayNotification: 'auth/displayNotification',
        }),
       
        updateEmailaddress() {
            let datax={
                  emailaddress:this.emailaddress,
                  settings: this.settings,
                  footer: this.footer,
                  public: this.publiccheck,
                  default: this.defaultcheck,
                  committee: this.committees,
                  user: this.users,
                  id:this.id
            };

            var data={
                endpoint:'/api/v1/update-emailaddress/'+this.id,
                details:datax,
            };

            this.$store.dispatch('put',data).then((data)=>{
                console.log(data)
                this.displayNotification({type:'success',title:'Success','message':"Successfully completed",id:Math.round(Math.random() * 999),autoDismiss:true,interval:5000})
                this.$router.push({name: 'emailaddressesList'}) 
            })
        },

        myChangeEvent(val){
            console.log(val);
        },
        mySelectEvent({id, text}){
            console.log({id, text})
        }

    },
    computed:{
        
    },
    created(){
        this.$store.dispatch('get','api/v1/users/all').then((data)=>{
          console.log(data);
          this.users_arr = data.data.data;

          // ======== create key val =================
          for(let i=0; i<=this.users_arr.length;i++){
              if(typeof this.users_arr[i] != "undefined"){
                  console.log(this.users_arr[i].id);

                  this.format_user_arr.push({
                     id: this.users_arr[i].id,
                     text: this.users_arr[i].firstname+' '+this.users_arr[i].lastname
                  })
              }
             
          }
          //==============================================

        });

        this.$store.dispatch('get','api/v1/committees/all/parent-id').then((data)=>{
            console.log(data);
            this.committees_arr = data.data.data;

            // ======== create key val =================
            for(let i=0; i<=this.committees_arr.length;i++){
                if(typeof this.committees_arr[i] != "undefined"){
                    console.log(this.committees_arr[i].id);

                    this.format_committees_arr.push({
                        id: this.committees_arr[i].id,
                        text: this.committees_arr[i].title
                    })
                }
                
            }
            //==============================================
            
        });

        // get detail 
        let id=this.$route.params.id;
        this.$store.dispatch('get','/api/v1/get-emailaddress/'+id)
        .then(data=>{
            console.log(data);
            let temp=data.data.data;
            this.emailaddress = temp.emailaddress;

            temp.committees.forEach(item => {
                this.committees.push(item.id)
            })

            temp.users.forEach(item => {
                this.users.push(item.id)
            })
            
            this.settings = temp.settings;
            this.footer = temp.footer;
            this.publiccheck = temp.public;
            this.defaultcheck = temp.default;
            this.id = temp.id;
            
        })
        .catch(error=>{
            console.log(error.request);
        });

    },
    watch:{
       
    }
}
</script>

<style lang="stylus" scoped>

</style>